import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import Text from 'components/Core/Text';
import { CareersLifeHoverSection } from './styles';

const CareersLifeHover = ({
  lifeImpact,
  lifeIntrapenuership,
  lifeAcceleration,
  lifeCollage,
  ...otherProps
}) => {
  const tabs = [
    {
      title: 'Impact',
      image: lifeImpact,
      copy:
        'There are hundreds of thousands of homeowners in the US, and that many more globally. I get to build systems that help our customers better serve those homeowners and their communities. We are changing lives by putting the power of technology to work for everyday Americans; that impact is what motivates me.',
      name: 'JonDelina Buckley',
      role: 'Director, Service Design at ServiceTitan',
    },
    {
      title: 'Intrapreneurship',
      image: lifeIntrapenuership,
      copy:
        'The Growth team is constantly exploring new opportunities to scale and better service our customers. There are boundless new verticals and territories we could pursue, making ServiceTitan a truly blue ocean of potential.',
      name: 'Leslie Gildea',
      role: 'Vice President of Growth Development',
    },
    {
      title: 'Acceleration',
      image: lifeAcceleration,
      copy:
        'I started my professional career working in retail banking; never did I imagine running a global team and function. ServiceTitan has created opportunities for me beyond my wildest imagination.',
      name: 'Vach Hovsepyan',
      role: 'Head of International Strategy and Operations',
    },
  ];
  const [pulse, setPulse] = useState(null);
  const [firstHover, setFirstHover] = useState(false);
  const [selectedIndex, setSelectedIndex] = useState(0);
  const [hovering, setHovering] = useState(false);
  const [displayTooltip, toggleDisplayTooltip] = useState(false);
  const [pulseTimerId, setPulseTimerId] = useState(null);
  const [tooltipTimerId, setTooltipTimerId] = useState(null);
  const [defaultPhoto, setDefaultPhoto] = useState(true);

  const featuredContent = selectedIndex !== null ? tabs[selectedIndex] : '';

  const featuredImage = featuredContent.image;
  const featuredCopy = featuredContent.copy;
  const featuredName = featuredContent.name;
  const featuredRole = featuredContent.role;

  useEffect(() => {
    clearTimeout(tooltipTimerId);
    toggleDisplayTooltip(false);

    if (hovering) {
      const timer = () =>
        setTimeout(() => {
          toggleDisplayTooltip(true);
        }, 3000);
      const timerId = timer();
      setTooltipTimerId(timerId);
    }
  }, [hovering, selectedIndex, firstHover]);

  const handleItemHover = (index, hoverState) => {
    index === 0 && setFirstHover(true);
    setHovering(hoverState);
    setSelectedIndex(index);
    setPulse(false);
    hovering === true ? setDefaultPhoto(false) : setDefaultPhoto(true);
  };

  let navigationItems = [[], []];

  tabs.map((item, index) => {
    item.key = index;
    index % 2 === 0 ? navigationItems[0].push(item) : navigationItems[1].push(item);
  });

  return (
    <CareersLifeHoverSection {...otherProps}>
      <div className="careers--life-hover-container">
        <Text
          type={'h2'}
          alignDesktop={'Left'}
          size={'28px'}
          className="careers--underlined-heading"
          id="titanlife"
        >
          Life
        </Text>
        {tabs.map((item, index) => {
          return (
            <div
              onMouseEnter={() => handleItemHover(item.key, true)}
              onMouseLeave={() => handleItemHover(item.key, false)}
              className="careers--life-hover-item"
            >
              <Text type={'p'} alignDesktop={'center'}>
                {item.title}
              </Text>
            </div>
          );
        })}
      </div>
      <div id="careers--life-hover-content">
        <div
          className="careers--life-default-image"
          style={{
            display: 'block',
          }}
        >
          <img src={lifeCollage} />
        </div>
        <div
          className="careers--life-quote-content"
          style={{ display: hovering === true ? 'flex' : 'none' }}
        >
          <div
            className="careers--life-hover-image"
            style={{ backgroundImage: 'url(' + featuredImage + ')' }}
          ></div>
          <div className="careers--life-copy-container">
            <Text type={'p'} alignDesktop={'left'} className="careers--life-hover-quote">
              {featuredCopy}
            </Text>
            <Text type={'p'} alignDesktop={'left'} className="careers--life-quotee-name">
              {featuredName}
            </Text>
            <Text type={'p'} alignDesktop={'left'} className="careers--life-quotee-role">
              {featuredRole}
            </Text>
          </div>
        </div>
      </div>
    </CareersLifeHoverSection>
  );
};

CareersLifeHoverSection.propTypes = {
  lifeCollage: PropTypes.string,
};

export default CareersLifeHover;
